/**
 * SpotifyPill — collapsed bottom-right launcher.
 *
 * Always visible when the user is signed in and the player drawer is closed.
 * Single tap opens the full player drawer.
 */
import React from "react";
import { Music } from "lucide-react";

export default function SpotifyPill({ track, paused, accentStyle, onOpen }) {
  return (
    <button
      type="button"
      onClick={onOpen}
      style={accentStyle}
      className="fixed bottom-24 right-4 z-40 inline-flex items-center gap-2 pl-1.5 pr-3 py-1.5 rounded-full bg-black/40 backdrop-blur-2xl backdrop-saturate-150 border border-white/15 hover:border-[#1DB954]/60 text-white shadow-2xl shadow-black/50 transition-all max-w-[260px]"
      data-testid="spotify-pill-launcher"
      aria-label="Open music player"
    >
      {track?.album?.images?.[0]?.url ? (
        <img
          src={track.album.images[0].url}
          alt=""
          className="w-8 h-8 rounded-full object-cover shrink-0 ring-1 ring-white/10"
        />
      ) : (
        <div className="w-8 h-8 rounded-full bg-[#1DB954]/20 inline-flex items-center justify-center shrink-0">
          <Music className="w-4 h-4 text-[#1DB954]" />
        </div>
      )}
      <div className="flex-1 min-w-0 text-left">
        {track ? (
          <>
            <div className="text-[11px] text-white truncate font-bold leading-tight">{track.name}</div>
            <div className="text-[10px] text-white/50 truncate leading-tight">
              {(track.artists || []).map((a) => a.name).join(", ")}
            </div>
          </>
        ) : (
          <div className="text-[10px] uppercase tracking-widest text-white/70 leading-tight">
            Music
          </div>
        )}
      </div>
      {track && (
        <span
          className={`shrink-0 w-1.5 h-1.5 rounded-full ${paused ? "bg-white/30" : "bg-[#1DB954] animate-pulse"}`}
          aria-hidden
        />
      )}
    </button>
  );
}
